import { theme } from '@citygross/design-tokens';

type TGetLinkAttributes = {
  categoryLevel: number;
};

type TLinkAttributes = {
  backgroundColor?: string;
  hoverBackground?: string;
  paddingLeft?: number;
};

export const getLinkAttributes = ({
  categoryLevel
}: TGetLinkAttributes): TLinkAttributes => {
  switch (categoryLevel) {
    case 1:
      return {
        backgroundColor: theme.palette?.brandYellow,
        hoverBackground: theme.palette?.brandYellowHover
      };
    case 2:
      return {
        backgroundColor: theme.palette?.yellowLight,
        hoverBackground: theme.palette?.yellowLighter
      };
    default:
      return {
        backgroundColor: theme.palette?.yellowLighter,
        hoverBackground: theme.palette?.yellowLighter
      };
  }
};

export const categoryItemType = {
  ContentStructureContainer: 'ContentStructureContainer'
};
